var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"section-title"},[_c('h6',{staticClass:"text-left"},[_vm._v("Dúvida(s) encontrada(s)")])]),_c('Card',{attrs:{"type":"card-list","cards":_vm.cards}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }